import { render, staticRenderFns } from "./loginRmote.vue?vue&type=template&id=19efe4f9&scoped=true&"
import script from "./loginRmote.vue?vue&type=script&lang=js&"
export * from "./loginRmote.vue?vue&type=script&lang=js&"
import style0 from "./loginRmote.vue?vue&type=style&index=0&id=19efe4f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19efe4f9",
  null
  
)

export default component.exports